<template>
  <button :class="{disabled:disabledSend}"
          @click="smsSend(phoneNumber, terminalName, accountName)"
          :disabled="disabledSend">{{countDown}}{{value}}
  </button>
</template>

<script>
  import {api} from '../../../view/api/Login'
  import {nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    name: 'button-sms',
    props: ['phoneNumber', 'terminalName', 'accountName'],
    data () {
      return {
        disabledSend: false,
        countDown: '',
        value: '点击获取'
      }
    },
    methods: {
      smsSend (phoneNumber, terminalName, accountName) {
        this.disabledSend = true
        this.value = '秒后重发'
        this.countDown = 60
        this.$emit('clearVerifyCode')
        this.timeOver()
        this.$axios.post(`${api.sendVerificationCode}`, {
          phone: phoneNumber
        })
          .then(res => {
            nSuccess('短信已发送')
          })
          .catch(errorHandler('短信发送失败'))
      },
      timeOver () {
        if (this.countDown !== 0) {
          setTimeout(() => {
            this.countDown -= 1
            this.timeOver()
          }, 1000)
        } else {
          this.disabledSend = false
          this.value = '点击获取'
          this.countDown = ''
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .disabled {
    cursor: not-allowed;
    color: #999999;
  }

  button {
    min-width: 90px;
    text-align: center;
    padding: 4px 16px;
    border-radius: 5px;
    height: 32px;
    border: 1px #FFFFFF solid;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/buttons/button-sms.vue